// Evidence PDF section key → the Configure step where its inputs live, so a
// merchant can click a weak section and land where they can strengthen it.
export const SECTION_TO_CONFIGURE = {
  dispute_summary: "required_information",
  transaction_details: "checkout_policies",
  // CVV / AVS / 3-D Secure inputs live in the Verifications step, not checkout.
  avs_cvv_match: "verifications",
  shipping_proof_with_tracking: "evidence_vault",
  terms_and_conditions_appendix: "checkout_policies",
  refund_policy_appendix: "checkout_policies",
  cardholder_communication_history: "evidence_vault",
  identity_verification_ekata: "verifications",
  identity_verification_emailage: "verifications",
  stripe_radar_risk_score: "verifications",
  lead_argument: "required_information",
  merchant_attestation: "required_information"
}
